module.exports = __webpack_public_path__ + "img/zl6.9b8a9400.jpg";